import { FIND_CREDITS, GET_INITIAL_CREDITS, GET_ADITIONAL_CREDITS, GET_TYPE_CREDITS } from './../constants';
import { handleActions } from "redux-actions"

export const credits  = handleActions(
  {
    [ FIND_CREDITS ]: (state, action) => {
      const { error } = action.payload
      if (error) {
        return state 
      } else if(action.payload["timeout"] !== undefined ) {
        return state
      } else {
        return { ...state, tablePayment: action.payload.data }
      }
    },
    [ GET_INITIAL_CREDITS ]: (state, action) => {
      return { ...state, infoPayment: action.payload.data }
    },
    [ GET_ADITIONAL_CREDITS ]: (state, action) => {
      return { ...state, aditionalPayment: action.payload.data }
    },
    [ GET_TYPE_CREDITS ]: (state, action) => {
      return { ...state, types: action.payload.data }
    }
  }, {}
)